// Settings card: shows the connected PM5's serial (CE060012) + firmware version
// (CE060014), read on connect, and the status sample rate we wrote (CE060034).
import { useEffect, useState } from 'react';
import { Cpu } from 'lucide-react';

export const Pm5InfoCard = () => {
  const [info, setInfo] = useState(() => window.__crewzPm5DeviceInfo || null);
  const [rate, setRate] = useState(() => window.__crewzPm5SampleRate || null);

  useEffect(() => {
    const onInfo = (e) => setInfo(e.detail);
    const onRate = (e) => setRate(e.detail);
    window.addEventListener('crewz-pm5-deviceinfo', onInfo);
    window.addEventListener('crewz-pm5-samplerate', onRate);
    return () => {
      window.removeEventListener('crewz-pm5-deviceinfo', onInfo);
      window.removeEventListener('crewz-pm5-samplerate', onRate);
    };
  }, []);

  return (
    <div className="bg-white dark:bg-zinc-800 border border-zinc-200 dark:border-zinc-700 rounded-lg px-4 py-3" data-testid="pm5-info-card">
      <div className="flex items-center gap-2 mb-2">
        <Cpu className="w-4 h-4 text-zinc-500" />
        <span className="text-sm font-medium text-zinc-700 dark:text-zinc-300">PM5 device info</span>
      </div>
      {!info ? (
        <p className="text-xs text-zinc-400" data-testid="pm5-info-empty">Shown automatically when the PM5 connects.</p>
      ) : (
        <div className="text-[13px] font-mono text-zinc-700 dark:text-zinc-200 space-y-1">
          <div className="flex justify-between gap-3">
            <span className="text-zinc-400">Serial</span>
            <span data-testid="pm5-info-serial">{info.serial || '—'}</span>
          </div>
          <div className="flex justify-between gap-3">
            <span className="text-zinc-400">Firmware</span>
            <span data-testid="pm5-info-firmware">{info.firmware || '—'}</span>
          </div>
          {rate && (
            <div className="flex justify-between gap-3">
              <span className="text-zinc-400">Sample rate</span>
              <span data-testid="pm5-info-samplerate">{rate.value != null ? `${rate.label} (wrote ${rate.value})` : (rate.error || '—')}</span>
            </div>
          )}
        </div>
      )}
    </div>
  );
};
